import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "enums";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import OrderSummaryModule from "modules/inventory/order-summary-list-module";
import OrderSummaryDetailsModule from "modules/inventory/order-summary-details/order-summary-details.module";

const InventoryPage = () => {
  return (
    <Switch>
      <Route exact path={Path.OrderSummary} component={OrderSummaryModule} />
      <Route exact path={Path.OrderSummaryDetails} component={OrderSummaryDetailsModule} />
      <Route exact path={Path.ViewOrderSummaryDetails} component={OrderSummaryDetailsModule} />
      <Redirect to={Path.OrderSummary} />
    </Switch>
  );
};

export default InventoryPage;
